import { AuthService } from '@/modules/auth/services/auth.service';
import { $userData } from '@/modules/auth/store/auth.store';
import { DiContainer } from '@/modules/di/di-container';
import { createEffect, createEvent, createStore, sample } from 'effector';
import { IBuyer } from '../ts';

const authService = DiContainer.get(AuthService);

export const setBuyerData = createEvent<IBuyer>();
export const resetBuyerData = createEvent();

export const $buyerData = createStore<IBuyer>({
  companyName: '',
  address: '',
  phone: '+7 (',
  email: '',
  inn: '',
  ogrn: '',
});

export const fetchBuyerDataFx  = createEffect(async () => {
  const res = await authService.checkAuth();
  return res;
});

sample({
  target: setBuyerData,
  clock: fetchBuyerDataFx.doneData,
  fn: (data) => {
    return {
      companyName: data?.company.name || '',
      address: data?.company.address || '',
      phone: '',
      email: data?.email || '',
      inn: data?.company.inn || '',
      ogrn: data?.company.ogrn || '',
    };
  } 
})

$buyerData.on(setBuyerData, (_, p) => p)
// .on(resetBuyerData, (_s, _p) => ({
//   companyName: $userData?.company.name || '',
//       address: $userData?.company.address || '',
//       phone: '',
//       email: $userData?.email || '',
//       inn: $userData?.company.inn || '',
//       ogrn: $userData?.company.ogrn || '',
// }));

sample({
  source: $userData,
  target: $buyerData,
  fn: (data) => {
    return {
      companyName: data?.company.name || '',
      address: data?.company.address || '',
      phone: '',
      email: data?.email || '',
      inn: data?.company.inn || '',
      ogrn: data?.company.ogrn || '',
    };
  }
});
